<template>
    <!-- <div class="container">
        <img src="static/icons/loader.gif">
    </div> -->
    <div class="loader-container">
        <div class="loader" id="loader" :class="{'finish': finish}">
        <div class="spinner" :class="{'finish': finish, 'check': !loading}">
            <div :class="{'check': finish}"></div>
        </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Loader',
    props: ['loading', 'finish'],
    data () {
        return {}
    },
    mounted () {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.loader-container {
    height: 400px;
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
}

input {
    display: none;
}

.spinner.finish {
    animation: none;
    border-left: none;
    transition: border 0.5s ease-out;
}

.loader .check {
    display: block;
}

.spinner {
    width: 15rem;
    height: 15rem;
    position: relative;
    border-radius: 50%;
    // border: 2px solid #ccc;
    border-left: 5px solid #472db9;
    animation: spin .6s linear infinite, colorChange 3s linear infinite;
}

.spinner .check {
    border: none;
    border-left: none;
    top: 50%;
    left: 23px;
    width: 90px;
    content: "";
    height: 160px;
    position: absolute;
    transform-origin: left top;
    animation: check 0.8s ease;
    border-top: 4px solid #5cb85c;
    border-right: 4px solid #5cb85c;
    transform: scaleX(-1) rotate(135deg);
}

@keyframes check {
    0% {
        height: 0;
        width: 0;
        opacity: 1;
    }

    20% {
        height: 0;
        width: 90px;
        opacity: 1;
    }

    40% {
        height: 160px;
        width: 90px;
        opacity: 1;
    }

    100% {
        height: 160px;
        width: 90px;
        opacity: 1;
    }
}

@keyframes colorChange {
    40% {
        border-left: 5px solid #2db981;
    }

    60% {
        border-left: 5px solid #b97f2d;
    }

    80% {
        border-left: 5px solid #b92db2;
    }

    100% {
        border-left: 5px solid #b92d2d;
    }
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

@media (max-width: 698px) { // Gertec SK210
    .loader-container {
        height: 200px;
        width: 200px;
    }

    .spinner {
        width: 7rem;
        height: 7rem;
    }

    .spinner .check {
        top: 50%;
        left: -10px;
        width: 50px;
        height: 120px;
    }

    @keyframes check {
        0% {
            height: 0;
            width: 0;
            opacity: 1;
        }

        20% {
            height: 0;
            width: 50px;
            opacity: 1;
        }

        40% {
            height: 120px;
            width: 50px;
            opacity: 1;
        }

        100% {
            height: 120px;
            width: 50px;
            opacity: 1;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue